import { Input, Spin } from "antd";
import { useState, useMemo } from "react";

const TagSearchFilter = ({ tags, value, onChange, loading }) => {
  const [query, setQuery] = useState("");

  const suggestions = useMemo(() => {
    const lower = query.toLowerCase();
    return tags.filter(
      (t) => !value.includes(t.name) && t.name.toLowerCase().includes(lower),
    );
  }, [query, tags, value]);

  return (
    <div style={{ position: "relative", width: 200 }}>
      <Input
        placeholder="Filter by tag..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{ fontFamily: "Inter", height: "100%" }}
      />
      {loading && (
        <Spin size="small" style={{ position: "absolute", right: 8, top: 8 }} />
      )}
      {suggestions.length > 0 && query && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #d1d5db",
            borderRadius: 2,
            maxHeight: 180,
            overflowY: "auto",
            zIndex: 999,
          }}
        >
          {suggestions.map((tag) => (
            <div
              key={tag.id}
              onMouseDown={() => {
                onChange([...value, tag.name]);
                setQuery("");
              }}
              style={{
                padding: "6px 10px",
                cursor: "pointer",
                fontFamily: "Inter",
                fontSize: 12,
              }}
            >
              {tag.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagSearchFilter;